export default "__VITE_ASSET__2LcQvaMA__"